import { render, staticRenderFns } from "./PortfolioReturn.vue?vue&type=template&id=637e5910&"
import script from "./PortfolioReturn.vue?vue&type=script&lang=ts&"
export * from "./PortfolioReturn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports